//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getPhoneHref } from '../helpers.js'
import { cardPropertyObject } from './CardPropertyObject.js'

import ItemsSearchField from '../Field/ItemsSearchField.vue'
import CardPropertyObjectItem from './CardPropertyObjectItem.vue'
import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyObjectCustom',
  components: {
    ItemsSearchField,
    CardPropertyObjectItem,
    CardPropertyIcon
  },
  mixins: [cardPropertyObject, cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      columnView: false
    }
  },
  computed: {
    objectsCount: function () {
      const value = this.object[this.tabProp.key]
      if (value) {
        if (Array.isArray(value)) {
          return value.length
        } else {
          return 1
        }
      }
      return 0
    },
    readonly: function () {
      return !this.tabProp.editable || this.dependencyDisable
    },
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    },
    dependencyDisable: function () {
      if (this.componentProps && this.componentProps.getDependencyValue) {
        return !this.dependencyValue
      } else {
        return false
      }
    },
    dependencyValue: function () {
      if (this.componentProps && this.componentProps.getDependencyValue) {
        return this.componentProps.getDependencyValue(this.object)
      } else {
        return null
      }
    },
    phoneHref: function () {
      return getPhoneHref(this.object[this.tabProp.key])
    },
    showOpenCard: function () {
      if (this.tabProp.subType && this.object[this.tabProp.key] && this.object[this.tabProp.key].id) {
        switch (this.tabProp.subType) {
          case 'employee':
          case 'vehicle':
          case 'trafficLight':
          case 'vehicleProvision':
            return true
          default:
            return false
        }
      } else {
        return false
      }
    },
    showCreateCard: function () {
      const tabProp = this.tabProp
      if (tabProp.subType) {
        const createConfig = tabProp.componentProps && tabProp.componentProps.createConfig && tabProp.componentProps.createConfig || null
        switch (tabProp.subType) {
          case 'employee':
            return !!tabProp.subSubType && !this.readonly
          case 'vehicle':
            return !this.readonly
          default:
            return !this.readonly && !!createConfig
        }
      } else {
        return false
      }
    }
  },
  watch: {
    dependencyValue: function () {
      this.$refs.field.onClear()
    }
  },
  methods: {
    openCreateCard: function () {
      const tabProp = this.tabProp
      const objectSrc = this.object
      const createConfig = tabProp.componentProps && tabProp.componentProps.createConfig && tabProp.componentProps.createConfig || null

      const objectType = tabProp.subType
      const subtypeKey = tabProp.subSubType
      const objectParams = createConfig && createConfig.objectParams && createConfig.objectParams(objectSrc) || null

      const contentProps = {
        objectId: -1,
        objectType: objectType,
        subtypeKey: subtypeKey,
        objectParams: objectParams,
        create: true,
        createConfig: createConfig,
        modeCustom: true
      }

      let onCreated
      if (createConfig && createConfig.updateOnCreated) {
        onCreated = function () {
          objectSrc._card.updateObject()
        }
      }

      this.openObjectCardDialog(this, contentProps, onCreated)
    },
    openObjectCardDialog (target, contentProps, onCreated) {
      const dialog = target.$d.dialog(target).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 800,
        contentComponent: () => import('../Card/ObjectCardWrapper.vue'),
        contentProps: contentProps,
        componentHandlers: {
          created: (objectId) => {
            console.log('Создан объект, id=', objectId)

            if (onCreated) {
              onCreated(objectId)
            }
            dialog.hide()
          },
          saved: () => {}, // не будет, т.к. закрываем в created
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onOpenCard: function (event) {
      this.$d_showObjectCard(this.object[this.tabProp.key].id, this.tabProp.subType, event.ctrlKey, false, this.tabProp.subSubType)
    },
    onCall: function (e) {
      e.navigate = false
      this.onClickLink(this.phoneHref)
    },
    onClickLink: function (href) {
      if (href) {
        const a = document.createElement('a')
        a.href = href
        a.click()
      }
    },
    onCopy: function (e) {
      e.stopPropagation()
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.object[this.tabProp.key].map(entry => entry.name).join(', ')], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    }
  }
}
